(() => {
  if (window.__OSTUKLIKK_WISHLIST_FAST__) return;
  window.__OSTUKLIKK_WISHLIST_FAST__ = true;

  const STORAGE_KEY = 'wishlist_v1';
  const labels = {
    en: { add: 'Add to favorites', remove: 'Remove from favorites' },
    et: { add: 'Lisa lemmikutesse', remove: 'Eemalda lemmikutest' },
    fi: { add: 'Lisää suosikkeihin', remove: 'Poista suosikeista' },
    ru: { add: 'Добавить в избранное', remove: 'Удалить из избранного' }
  };

  function language() {
    const value = String(
      document.documentElement.lang ||
      window.Shopify?.locale ||
      'en'
    ).toLowerCase();
    if (value.startsWith('et')) return 'et';
    if (value.startsWith('fi')) return 'fi';
    if (value.startsWith('ru')) return 'ru';
    return 'en';
  }

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      return Array.isArray(value) ? [...new Set(value.filter(Boolean))] : [];
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    const value = [...new Set(items.filter(Boolean))].slice(0, 100);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (error) {
      /* The controls still update for this page when storage is unavailable. */
    }
    return value;
  }

  function update(items = read()) {
    const copy = new Set(items);
    const text = labels[language()];

    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const active = copy.has(handle);
      button.classList.toggle('wishlist-button--active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? text.remove : text.add);
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(element => {
      const count = items.length;
      const nextText = String(count);
      if (element.textContent !== nextText) element.textContent = nextText;
      if (element.hidden !== (count === 0)) element.hidden = count === 0;
    });
  }

  function toggle(handle) {
    if (!handle) return;
    const items = read();
    const index = items.indexOf(handle);
    const action = index === -1 ? 'add' : 'remove';

    if (index === -1) items.unshift(handle);
    else items.splice(index, 1);

    const saved = write(items);
    update(saved);
    document.dispatchEvent(new CustomEvent('wishlist:change', {
      detail: { items: saved, action, handle }
    }));
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-wishlist-button]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    toggle(button.dataset.productHandle);
  }, true);

  document.addEventListener('wishlist:change', event => {
    update(Array.isArray(event.detail?.items) ? event.detail.items : read());
  });

  document.addEventListener('shopify:section:load', () => update());

  document.addEventListener('change', event => {
    if (
      event.target instanceof Element &&
      event.target.matches('select[name="locale_code"], input[name="locale_code"]')
    ) {
      update();
    }
  });

  window.addEventListener('storage', event => {
    if (event.key === STORAGE_KEY) update();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => update(), { once: true });
  } else {
    update();
  }
})();